import { getAuth } from 'firebase/auth';

const fetchFromAdmin = (
  dataPrefix: string,
  method: string,
  data?: any
): Promise<any> => {
  const responseId = Math.random().toString(36).substring(7);

  return new Promise((resolve) => {
    const waitForData = (event: any) => {
      if (event?.data?.type === responseId) {
        window.removeEventListener('message', waitForData);
        resolve(event?.data?.data);
      }
    };

    window.addEventListener('message', waitForData);

    void (async () => {
      let caFirebaseIdToken: string | null = null;
      try {
        const auth = getAuth();
        if (auth.currentUser) {
          caFirebaseIdToken = await auth.currentUser.getIdToken();
        }
      } catch {
        /* not signed in yet (e.g. before auth/login-token completes) */
      }

      (window as any).parent.postMessage(
        {
          type: 'fetch',
          data: {
            payload: data,
            dataPrefix,
            method,
            responseId,
            caFirebaseIdToken,
          },
        },
        '*'
      );
    })();
  });
};

const INTERCEPTED_ENDPOINTS = [
  'auth/login-token',
  'auth',
  '/auth/start_registration',
  'auth/verify-captcha',
  '/auth/generate_registration_id',
  'auth/update',
];

const adminRegistrationMockCalls = (
  endpoint: string,
  method: string,
  data: any
): Promise<any> | null => {
  if (INTERCEPTED_ENDPOINTS.includes(endpoint)) {
    return fetchFromAdmin(endpoint, method, data);
  }

  if (endpoint.startsWith('products/register/')) {
    return fetchFromAdmin(endpoint, method, data);
  }

  return null;
};

export default adminRegistrationMockCalls;
